import { LOCATION_CHANGE } from './actions';
import { injectQuery } from './helpers/injectQuery';

export const routerReducer = (history) => {
  return {};
  // const initialState = {
  //   current: {
  //     location: injectQuery(history.location),
  //     action: history.action,
  //   },
  //   previous: {},
  // };

  // return (state = initialState, action) => {
  //   const { type, payload } = action;

  //   if (type === LOCATION_CHANGE) {
  //     return {
  //       current: {
  //         location: injectQuery(payload.location),
  //         action: payload.action,
  //       },
  //       previous: state.current,
  //     };
  //   }

  //   return {};
  // };
};
